import React, { Component, Fragment } from "react";
import DeleteModel from "./DeleteModel";
import EditModel from "./EditModel";
import PrimaryModel from "./PrimaryModel";
import AppContext from "../../../contexts/AppContext";

class PaymentMethodList extends Component {
    state = {
        delete: false,
        update: false,
        primary:false,
        item: {}
    };

    /* delete */
    delete = () => {
        return this.props.delete(this.props.item.id);
    };    

    toggleDelete = () => {
        this.setState({ delete: this.state.delete === true ? false : true });
    };

    togglePrimary = () => {
        this.setState({ primary: this.state.primary === true ? false : true });
    };  

    toggleUpdate = () => {
        this.state.update === true
            ? this.setState({ update: false })
            : this.props
                  .getItem(this.props.item.id)
                  .then(response => {
                      this.setState({ update: true, item: response.data });
                  })
                  .catch(error => {
                      this.context.state.handelError(error);
                  });
    };

    render() {
        return (
            <Fragment>
                <div className={this.props.item.primary === '1' ? 'primary col-12' : 'col-12'}>
				    {/*<td>{this.props.item.id}</td>*/}
                    <div className="card align-items-center flex-row">
                        <img src={`/cards/${this.props.item.type.charAt(0).toUpperCase() + this.props.item.type.slice(1)}.png`} className="card-img-top" alt=""></img>
                        <div className="card-body p-0 d-flex align-items-center">
                            <div>
                                <h5 className="card-title pl-3 mb-1"><span className="mr-2">{this.props.item.type}</span>•••• {this.props.item.code}</h5>
                                <p className="card-text pl-3 m-0">Expires {this.props.item.expiry}</p>
                                { (this.props.item.payment_method_type == 'gpay-checkout') && <p className="card-text pl-3 m-0">Google Wallet Card</p>}
							</div>
                            
							<div>
							    {this.props.item.primary === '0' ?
								    <span onClick={this.togglePrimary}>Make Primary</span>
								: 
								    <span className="text-muted">Primary</span>
								}
                                {(this.props.item.payment_method_type == 'card-checkout' || this.props.item.payment_method_type == null) ? <span onClick={this.toggleUpdate}>Edit</span> : ''}
							    
                                
                                {
                                    (this.props.item.payment_method_type == 'card-checkout' || this.props.item.payment_method_type == null) && this.props.total > 1 && this.props.item.primary === '0' ?
                                    <span onClick={this.toggleDelete}>Delete</span>
								: 
								    ''
								}
							</div>	
                        </div>
                    </div>
				</div>
                {this.state.delete === true ? (
                    <DeleteModel
                        delete={this.delete}
                        hideDelete={this.toggleDelete}
                    ></DeleteModel>
                ) : null}

                {this.state.update === true ? (
                    <EditModel
                        item={this.state.item}
                        update={this.props.update}
                        hideUpdate={this.toggleUpdate}
                    ></EditModel>
                ) : null}

                {this.state.primary === true ? (
                    <PrimaryModel    
                        item={this.props.item}                   
                        primary={this.props.primary}
                        hidePrimary={this.togglePrimary}
                    ></PrimaryModel>
                ) : null}

                
            </Fragment>
        );
    }
}
PaymentMethodList.contextType = AppContext;
export default PaymentMethodList;



// WEBPACK FOOTER //
// ./src/components/writer/billing/PaymentMethodList.js